import React from "react";

import {ILocationGenericParagraphSingleText, TextType} from "../../../helpers/location_generic_description/constants";

interface IProps {
    singleText: ILocationGenericParagraphSingleText;
}

export const ParagraphSingleTextType = ({singleText}: IProps) => {
    if (typeof singleText === "string") {
        return <>{singleText}</>;
    }

    switch (singleText.type) {
        case TextType.LINK:
            return (
                <a href={singleText.href} target="_blank" title={singleText.text}>
                    {singleText.text}
                </a>
            );
        default:
            return null;
    }
};
import React from "react";

import {ILocationGenericParagraphSingleText, TextType} from "../../../helpers/location_generic_description/constants";

interface IProps {
    singleText: ILocationGenericParagraphSingleText;
}

export const ParagraphSingleTextType = ({singleText}: IProps) => {
    if (typeof singleText === "string") {
        return <>{singleText}</>;
    }

    switch (singleText.type) {
        case TextType.LINK:
            return (
                <a href={singleText.href} target="_blank" title={singleText.text}>
                    {singleText.text}
                </a>
            );
        default:
            return null;
    }
};
